const noFilmOption = {
  id: "no-film",
  name: "Fara folie",
  vlt: "Original",
  productId: "none",
  productName: "Fara folie",
  opacity: 0,
  price: 0,
  swatch: "#eef1f4",
  description: "Geamurile raman exact ca in imaginea initiala.",
};

const productNames = {
  "global-hp-charcoal": "Global HP Charcoal",
  "global-qdp-ceramic": "Global QDP Ceramic",
  "global-ir-supreme": "Global IR Supreme",
  "protector-new-black-plus": "Protector New Black Plus",
};

const filmVariants = {
  "global-hp-charcoal": [
    { percent: 5, price: 74, variantId: "48000407896397" },
    { percent: 10, price: 74, variantId: "47983039906125" },
    { percent: 20, price: 74, variantId: "47983041511757" },
    { percent: 30, price: 74, variantId: "47983042625869" },
    { percent: 40, price: 74, variantId: "47983043576141" },
    { percent: 50, price: 74, variantId: "47983044952397" },
  ],
  "global-qdp-ceramic": [
    { percent: 5, price: 135, variantId: "48000987267405" },
    { percent: 18, price: 142, variantId: "48001002471757" },
    { percent: 33, price: 142, variantId: "48001004110157" },
    { percent: 46, price: 135, variantId: "48001246560589" },
    { percent: 70, price: 175, variantId: "48001263927629" },
    { percent: 80, price: 175, variantId: "48001272381773" },
    { percent: 86, price: 142, variantId: "48001280868685" },
  ],
  "global-ir-supreme": [
    { percent: 5, price: 171, variantId: "48001287848269" },
    { percent: 15, price: 172, variantId: "48001291682125" },
    { percent: 30, price: 171, variantId: "48001292796237" },
    { percent: 50, price: 171, variantId: "49761742487885" },
    { percent: 70, price: 192, variantId: "47985066705229" },
  ],
  "protector-new-black-plus": [
    { percent: 5, price: 41, variantId: "50462088298829" },
    { percent: 15, price: 68, variantId: "50462532698445" },
    { percent: 25, price: 68, variantId: "50462561993037" },
  ],
};

function buildFilm(productId, variant) {
  const percent = variant.percent;
  const padded = String(percent).padStart(2, "0");

  return {
    id: `${productId}-${padded}`,
    name: `${percent}%`,
    vlt: `${percent}%`,
    productId,
    productName: productNames[productId],
    percent,
    price: variant.price,
    variantId: variant.variantId,
    opacity: Math.max(0, Math.min(0.95, 1 - percent / 100)),
    swatch: swatchForPercent(percent),
    description: `${productNames[productId]} ${percent}% transparenta, ${variant.price} lei / metru.`,
  };
}

function swatchForPercent(percent) {
  const lightness = Math.max(4, Math.min(70, Math.round(percent * 0.72)));
  return `hsl(205 10% ${lightness}%)`;
}

function getFilmsForProduct(productId) {
  return [
    noFilmOption,
    ...(filmVariants[productId] || []).map((variant) => buildFilm(productId, variant)),
  ];
}

const products = [
  {
    id: "global-hp-charcoal",
    name: "Global HP Charcoal",
    url: "/products/global-hp-charcoal",
  },
  {
    id: "global-qdp-ceramic",
    name: "Global QDP Ceramic",
    url: "/products/global-qdp-ceramic",
  },
  {
    id: "global-ir-supreme",
    name: "Global IR Supreme",
    url: "/products/global-ir-supreme",
  },
  {
    id: "protector-new-black-plus",
    name: "Protector New Black Plus",
    url: "/products/protector-new-black-plus",
  },
];

const materialNeeds = {
  front: 2,
  back: 3,
  width: 1.52,
};

const imageConfig = {
  vehicle: "https://cdn.shopify.com/s/files/1/0793/2533/1789/files/desen.png?v=1776254664",
};

const state = {
  frontFilmId: "no-film",
  backFilmId: "no-film",
  productId: "global-qdp-ceramic",
};

const stockState = {
  byVariantId: {},
};

const els = {
  frontFilmOptions: document.querySelector("#front-film-options"),
  backFilmOptions: document.querySelector("#back-film-options"),
  productSelect: document.querySelector("#product-select"),
  tintLayer: document.querySelector("#tint-layer"),
  frontWindow: document.querySelector(".tint-front-window"),
  backWindow: document.querySelector(".tint-back-window"),
  frontWindowLabel: document.querySelector("#front-window-label"),
  backWindowLabel: document.querySelector("#back-window-label"),
  selectedFilm: document.querySelector("#selected-film"),
  selectedVlt: document.querySelector("#selected-vlt"),
  materialTotal: document.querySelector("#material-total"),
  materialBreakdown: document.querySelector("#material-breakdown"),
  frontWarning: document.querySelector("#front-warning"),
  summaryTitle: document.querySelector("#summary-title"),
  summaryCopy: document.querySelector("#summary-copy"),
  shopLink: document.querySelector("#shop-link"),
  resetConfig: document.querySelector("#reset-config"),
  vehicleImage: document.querySelector("#vehicle-image"),
};

function init() {
  setupVehicleImage();
  renderProductOptions();
  syncControls();
  bindEvents();
  loadStockAvailability();
}

function setupVehicleImage() {
  if (!imageConfig.vehicle) {
    els.vehicleImage.hidden = true;
    return;
  }

  els.vehicleImage.src = imageConfig.vehicle;
  els.vehicleImage.hidden = false;
}

function renderFilmOptions(product, target) {
  const films = getFilmsForProduct(product.id);
  const container = target === "front" ? els.frontFilmOptions : els.backFilmOptions;
  const selectedId = target === "front" ? state.frontFilmId : state.backFilmId;
  container.innerHTML = "";

  films.forEach((film) => {
    const stock = getFilmStock(film);
    const button = document.createElement("button");
    button.className = "film-option";
    button.type = "button";
    button.disabled = !stock.available;
    button.dataset.filmId = film.id;
    button.setAttribute("role", "radio");
    button.setAttribute("aria-checked", String(film.id === selectedId));
    button.classList.toggle("is-selected", film.id === selectedId);
    button.classList.toggle("is-out-of-stock", !stock.available);
    button.innerHTML = `
      <span class="swatch" style="background:${film.swatch}"></span>
      <span>
        <strong>${film.name}</strong>
        <small>${stock.available ? film.vlt : "Fara stoc"}</small>
      </span>
    `;
    button.addEventListener("click", () => {
      if (!stock.available) return;

      if (target === "front") {
        state.frontFilmId = film.id;
      } else {
        state.backFilmId = film.id;
      }
      syncControls();
    });
    container.append(button);
  });
}

function renderProductOptions() {
  els.productSelect.innerHTML = products
    .map((product) => `<option value="${product.id}">${product.name}</option>`)
    .join("");
}

function bindEvents() {
  els.productSelect.addEventListener("change", () => {
    const product = getProduct(els.productSelect.value);
    state.productId = product.id;
    syncControls();
  });

  els.resetConfig.addEventListener("click", () => {
    state.frontFilmId = noFilmOption.id;
    state.backFilmId = noFilmOption.id;
    syncControls();
  });

  els.shopLink.addEventListener("click", addSelectionToCart);
}

function syncControls() {
  const product = getProduct(state.productId);
  const frontFilm = getFilmById(state.frontFilmId);
  const backFilm = getFilmById(state.backFilmId);
  const material = getMaterialSummary(frontFilm, backFilm);
  state.frontFilmId = frontFilm.id;
  state.backFilmId = backFilm.id;

  renderFilmOptions(product, "front");
  renderFilmOptions(product, "back");
  els.productSelect.value = product.id;

  els.frontWindow.style.opacity = frontFilm.opacity;
  els.backWindow.style.opacity = backFilm.opacity;
  els.frontWindowLabel.textContent = `Fata: ${frontFilm.vlt}`;
  els.backWindowLabel.textContent = `Spate: ${backFilm.vlt}`;
  els.frontWindowLabel.hidden = frontFilm.id === noFilmOption.id;
  els.backWindowLabel.hidden = backFilm.id === noFilmOption.id;
  els.frontWarning.hidden = !frontFilm.percent || frontFilm.percent >= 86;
  els.selectedFilm.textContent = `Fata: ${frontFilm.productName} / Spate: ${backFilm.productName}`;
  els.selectedVlt.textContent = `Fata: ${frontFilm.vlt} / Spate: ${backFilm.vlt}`;
  els.materialTotal.textContent = `${formatMeters(material.total)} metri liniari - ${material.priceTotal} lei TVA inclus`;
  els.materialBreakdown.textContent = material.breakdown;
  els.summaryTitle.textContent = `${material.priceTotal} lei - TVA inclus`;
  els.summaryCopy.textContent = `Geam fata: ${frontFilm.description} Geam spate: ${backFilm.description}`;
  els.shopLink.href = "/cart";
  els.shopLink.classList.toggle("is-disabled", material.total === 0);
  els.shopLink.setAttribute("aria-disabled", String(material.total === 0));
}

async function loadStockAvailability() {
  try {
    const variantIds = [...new Set(getAllFilms().map((film) => film.variantId).filter(Boolean))];
    const variantsData = await Promise.all(
      variantIds.map((variantId) =>
        fetch(`/variants/${variantId}.js`, { headers: { Accept: "application/json" } })
          .then((response) => {
            if (!response.ok) throw new Error(`Stoc indisponibil pentru varianta ${variantId}`);
            return response.json();
          })
          .then((variant) => ({ variantId, available: Boolean(variant.available) }))
      )
    );

    variantsData.forEach((variant) => {
      stockState.byVariantId[String(variant.variantId)] = variant.available;
    });

    resetUnavailableSelections();
    syncControls();
  } catch (error) {
    console.warn("Nu s-a putut verifica stocul variantelor.", error);
  }
}

function getFilmStock(film) {
  if (film.id === noFilmOption.id || !film.variantId) {
    return { available: true };
  }

  const available = stockState.byVariantId[film.variantId];
  return { available: available !== false };
}

function resetUnavailableSelections() {
  const frontFilm = getFilmById(state.frontFilmId);
  const backFilm = getFilmById(state.backFilmId);

  if (!getFilmStock(frontFilm).available) {
    state.frontFilmId = noFilmOption.id;
  }

  if (!getFilmStock(backFilm).available) {
    state.backFilmId = noFilmOption.id;
  }
}

function getProduct(id) {
  return products.find((product) => product.id === id) || products[0];
}

function getFilmById(filmId) {
  if (filmId === noFilmOption.id) return noFilmOption;

  return getAllFilms().find((film) => film.id === filmId) || noFilmOption;
}

function getAllFilms() {
  return Object.keys(filmVariants).flatMap((productId) =>
    filmVariants[productId].map((variant) => buildFilm(productId, variant))
  );
}

function getMaterialSummary(frontFilm, backFilm) {
  const rows = [];
  let total = 0;
  let priceTotal = 0;

  if (frontFilm.id !== noFilmOption.id) {
    total += materialNeeds.front;
    priceTotal += materialNeeds.front * frontFilm.price;
    rows.push(`Fata: ${formatMeters(materialNeeds.front)} x ${formatMeters(materialNeeds.width)} m (${frontFilm.price} lei/ml)`);
  }

  if (backFilm.id !== noFilmOption.id) {
    total += materialNeeds.back;
    priceTotal += materialNeeds.back * backFilm.price;
    rows.push(`Spate: ${formatMeters(materialNeeds.back)} x ${formatMeters(materialNeeds.width)} m (${backFilm.price} lei/ml)`);
  }

  return {
    total,
    priceTotal,
    breakdown: rows.length ? rows.join(" / ") : "Alege folie pentru geamul fata sau spate.",
  };
}

async function addSelectionToCart(event) {
  event.preventDefault();

  const frontFilm = getFilmById(state.frontFilmId);
  const backFilm = getFilmById(state.backFilmId);
  const items = getCartItems(frontFilm, backFilm);

  if (!items.length) {
    els.summaryTitle.textContent = "Alege cel putin o folie";
    els.summaryCopy.textContent = "Selecteaza o transparenta pentru geamul fata sau spate inainte de adaugarea in cos.";
    return;
  }

  els.shopLink.classList.add("is-loading");
  els.shopLink.textContent = "Se adauga...";

  try {
    const response = await fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify({ items }),
    });

    if (!response.ok) {
      throw new Error("Shopify nu a acceptat adaugarea in cos.");
    }

    window.location.href = "/cart";
  } catch (error) {
    els.summaryTitle.textContent = "Nu s-a putut adauga in cos";
    els.summaryCopy.textContent = "Verifica daca esti pe site-ul Shopify si daca variantele sunt active in magazin.";
    els.shopLink.classList.remove("is-loading");
    els.shopLink.textContent = "Adauga in cos";
  }
}

function getCartItems(frontFilm, backFilm) {
  const items = [];

  if (frontFilm.id !== noFilmOption.id) {
    if (getFilmStock(frontFilm).available) {
      items.push(makeCartItem(frontFilm, "Geam fata", materialNeeds.front));
    }
  }

  if (backFilm.id !== noFilmOption.id) {
    if (getFilmStock(backFilm).available) {
      items.push(makeCartItem(backFilm, "Geam spate, inclusiv luneta", materialNeeds.back));
    }
  }

  return items;
}

function makeCartItem(film, windowName, linearMeters) {
  return {
    id: film.variantId,
    quantity: linearMeters,
    properties: {
      Geam: windowName,
      Brand: film.productName,
      Transparenta: film.vlt,
      "Metri liniari": formatMeters(linearMeters),
      "Latime rola": `${formatMeters(materialNeeds.width)} m`,
      "Pret configurator": `${linearMeters * film.price} lei TVA inclus`,
    },
  };
}

function formatMeters(value) {
  return Number.isInteger(value) ? String(value) : String(value).replace(".", ",");
}

init();
